import { PocTooltip } from 'commons/components/components-wrapper';
import styled from 'styled-components';

export const StyledTooltipedText = styled.div`
    display: block !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap !important;

    .blue-tooltip-span {
        color: #0b41cd;
    }
`;

export const TooltipedElmWrapper = styled.div`
    pointer-events: auto;
`;

export const TooltipElm = styled(PocTooltip)`
    z-index: 999;
`;
